import React, { PureComponent } from 'react';
import looppa from 'looppa';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { side, contentPages } from 'constants/menus';
import t, { Trans } from 'translations';
import Icon from 'components/icon';
import Aria51 from 'components/aria-51';
import MigrosLoginButton from 'components/migros-login-button';
import ContactInfo from 'components/contact-info';
import PaymentPlatforms from 'components/payment-platforms';

class SidePanelNav extends PureComponent {
    static propTypes = {
        openModal: PropTypes.func.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
        userRegion: PropTypes.object,
        currentRouteName: PropTypes.string,
        isModalOpen: PropTypes.bool.isRequired,
        hasCumulus: PropTypes.bool.isRequired,
        login: PropTypes.func.isRequired,
        logout: PropTypes.func.isRequired,
    };

    render() {
        const { isAuthenticated, openModal, userRegion, currentRouteName, hasCumulus, login, logout, isModalOpen } = this.props;

        return (
            <Aria51 className="side-panel-nav">
                <nav className="side-panel-nav--nav">
                    <ul className="side-panel-nav--list u-reset">
                        {looppa(side({ currentRouteName, isAuthenticated, hasCumulus }))((item, i) => (
                            <li key={i} className="side-panel-nav--item">
                                <NavLink
                                    exact
                                    activeClassName="side-panel-nav--link__is-active"
                                    className="side-panel-nav--link u-reset"
                                    to={item.url}
                                >
                                    <Trans path={item.title}/>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="side-panel-nav--user-status">
                    <ul className="side-panel-nav--list u-reset">
                        <li
                            className="side-panel-nav--item side-panel-nav--item__highlighted"
                            onClick={() =>
                                openModal({
                                    layout: 'zip-form',
                                })}
                        >
                            <Icon className="side-panel-nav--list-icon" size="medium" symbol="location"/>
                            {userRegion ? <Trans path={'user.my_zip_code'}/> :
                                <Trans className="side-panel-nav--zip-link" path="zip.header.link"/>}
                            <button
                                aria-haspopup="true"
                                aria-expanded={isModalOpen}
                                aria-label={userRegion ? t('accessibility.label.update_zip') : t('zip.form.placeholder')}
                                className="side-panel-nav--list-action">
                                {userRegion ? userRegion.zip : null}
                                <Icon size="medium" className="side-panel-nav--action-icon" symbol="pen"/>
                            </button>
                        </li>
                        <li className="side-panel-nav--item side-panel-nav--item__highlighted side-panel-nav--item__migros-login"
                            onClick={() => (isAuthenticated ? logout() : login())}>
                            {!isAuthenticated &&
                            <Icon className="side-panel-nav--list-icon" size="medium" symbol="profil"/>}
                            <MigrosLoginButton facet="side-panel-nav"/>
                        </li>
                    </ul>
                </div>
                <nav className="side-panel-nav--nav">
                    <ul className="side-panel-nav--list u-reset">
                        {looppa(contentPages())((item, i) => (
                            <li key={i} className="side-panel-nav--item">
                                <NavLink
                                    exact
                                    activeClassName="side-panel-nav--link__is-active"
                                    className="side-panel-nav--link u-reset"
                                    to={item.url}
                                >
                                    <Trans path={item.title}/>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="side-panel-nav--section">
                    <ContactInfo/>
                </div>

                <div className="side-panel-nav--section">
                    <PaymentPlatforms/>
                </div>
            </Aria51>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        userRegion: 'region.active',
        isModalOpen: 'modal.isVisible',
        isAuthenticated: 'user.isAuthenticated',
        hasCumulus: 'user.cumulus_connected',
        currentRouteName: 'router.name',
    }),
    reduxUtils.mapDispatchToProps({
        openModal: 'modal.open',
        login: 'user.login',
        logout: 'user.logout',
    }),
)(SidePanelNav);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/side-panel-nav/index.js